import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import '../../styling/ClientPortal.css';
import ClientGalleryTab from "../tabs/ClientGalleryTab";
import ClientEventsTable from "../tables/ClientEventsTable";

const ClientLandingPage = ({ brandingColours, handleTabSwitch, events, clientId }) => {
  return (
    <div style={{ paddingTop: '15px'}} className="clientLandingPageTabs">
      <Tabs>
        <TabList>
          <Tab>Events</Tab>
          <Tab>Gallery</Tab>
        </TabList>
 
        <TabPanel>
          <ClientEventsTable
            event={events}
            brandingColours={brandingColours}
            onEventClick={() => handleTabSwitch('portal')} // Switch to the ClientPortal
          />
        </TabPanel>
        <TabPanel>
          <ClientGalleryTab brandingColours={brandingColours} clientId={clientId}/>
        </TabPanel>
      </Tabs>
    </div>
  );
};

export default ClientLandingPage;